
export const rake_percent = 10;
export const collection = "ApexDucks";
export const collection_H = collection + " #";
export const waiting_reload_seconds = 30;
export const ready_at_seconds = 10;
export const race_at_seconds = 60;
export const finished_at_seconds = 90;
